import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'


function About({ aboutContent, loading }) {
  return (
    <>
      <section className="section__about">
        <div className="center insurtech__title pos-relative">
          <div className="about__container">
            {
              loading
                ? <SkeletonTheme baseColor="#aad7db14" highlightColor="#9fcfd3" height="25px">
                  <Skeleton width={"40%"} />
                  <Skeleton width={"80%"} />
                  <Skeleton width={"80%"} />
                  <Skeleton width={"40%"} />
                  <Skeleton count={5} />
                </SkeletonTheme>

                :
                <div className="about__columns w-row">
                  <div className="about__column-left w-col w-col-6 w-col-stack">
                    <div className="banner__info-uppertitle">{aboutContent?.ENS_partner_upper}</div>
                    <div className="default_title" dangerouslySetInnerHTML={{ __html: aboutContent?.ENS_partner_title }} />
                    <div className="default__uupertitle" dangerouslySetInnerHTML={{ __html: aboutContent?.ENS_partner }} />
                  </div>
                  <div className="about__column-right w-col w-col-6 w-col-stack">
                    <div className="banner__info-uppertitle">{aboutContent?.discount_upper}</div>
                    <div className="default_title" dangerouslySetInnerHTML={{ __html: aboutContent?.discount_title }} />
                    <div className="default__uupertitle" dangerouslySetInnerHTML={{ __html: aboutContent?.discount_programs }} />
                  </div>
                </div>
            }

          </div>
        </div>
      </section>
    </>
  )
}

export default About